export default __webpack_public_path__ + "static/media/marauders-map-v5.0-03-00.1d4e1843.jpg";